export default __webpack_public_path__ + "maps-examples-view-annotation-basic-thumbnail-480-5405c743c6d0ee31dbac2abfb5713227.png";